/**
 * @generated SignedSource<<57d732833ec2c3e3d875d1bdb360e85b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventList_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventItemNew_query">;
  readonly " $fragmentType": "EventList_query";
};
export type EventList_query$key = {
  readonly " $data"?: EventList_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventList_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventList_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventItemNew_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "470e0743dca9c1bcb2908f7a0e27ff6a";

export default node;
